<template>
    <div>

        <div class="panel panel-info">
            <div class="panel-heading">COMANDOS CADASTRADOS</div>
            <div class="panel-body" >

                <table id="mytable" class="table table-bordred table-striped">

                    <thead>
                        <tr>
                            <th>COMANDO</th>
                            <th style="text-align: center;width: 90px">STATUS</th>
                            <!--<th style="text-align: center;width: 140px">DATA</th>-->
                            <th style="text-align: center;width: 140px">AÇÕES</th>
                        </tr>
                    </thead>

                    <tbody>

                    <tr v-for="r in comandos" v-bind:key="r._id">
                        <td>{{r.comando}}</td>
                        <td style="text-align: center">{{r.status}}</td>
                        <!--<td style="text-align: center">{{r.created_at | date('dd/mm/yyyy HH:MM:ss')}}</td>-->
                        <td style="text-align: center">
                            <button @click="excluir(r._id)" class="btn btn-danger btn-xs">EXCLUIR</button>
                        </td>
                    </tr>

                    </tbody>

                </table>

                <button v-if="comandos.length" @click="excluirAll()" class="btn btn-danger btn-block">EXCLUIR TODOS OS COMANDOS</button>

            </div>

        </div>
    </div>
</template>
<script>
import { Contratos } from "../../class/contratos";
import { date } from "../../filters";
/*global swal*/
export default {
    props: {
        id: {
            default: null
        }
    },
    filters: {
        date
    },
    data() {
        return {
            comandos: [],
            user: null,
            interval: null
        };
    },
    beforeMount() {
        this.user = this.$store.state.user;
        this.$parent.$on("comandos", () => {
            this.loadComandos();
        });
    },
    mounted() {
        this.loadComandos();
        this.interval = setInterval(this.loadComandos, 60000);
    },
    beforeDestroy() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    },
    methods: {
        loadComandos() {
            Contratos.getComandos(this.id)
                .then(rows => (this.comandos = rows))
                .catch(err => console.log(err));
        },
        excluir(id) {
            swal.queue([
                {
                    title: "Comandos",
                    confirmButtonText: "Excluir Comando",
                    text: "Posso excluir o comando?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return new Promise((resolve, reject) => {
                            Contratos.excluirComandos(id)
                                .then(() => {
                                    this.loadComandos();
                                    resolve();
                                })
                                .catch(err => {
                                    console.log(err);
                                    reject();
                                });
                        });
                    }
                }
            ]);
        },
        excluirAll() {
            swal.queue([
                {
                    title: "Comandos",
                    confirmButtonText: "Excluir Comandos",
                    text: "Posso excluir todos os comandos?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return new Promise((resolve, reject) => {
                            Contratos.excluirAll(this.id)
                                .then(() => {
                                    this.loadComandos();
                                    resolve();
                                })
                                .catch(err => {
                                    console.log(err);
                                    reject();
                                });
                        });
                    }
                }
            ]);
        }
    }
};
</script>
